module.exports = __webpack_public_path__ + "media/images/emoticons/ribbon-d70b9eef53e6bd78f394147e5c2eb4d9.gif";